import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(form.email, form.password);
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === "string" ? detail : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6 grain">
      <div className="w-full max-w-md">
        <Link to="/" className="block mb-12 text-center" data-testid="admin-login-home-link">
          <div className="font-display text-3xl tracking-[0.3em] text-[#F9F6F0]">CHICA</div>
          <div className="overline mt-2 text-[10px]">Staff Portal</div>
        </Link>

        <div className="border border-[#2E3628] p-10 bg-[#1C2219]/60 backdrop-blur-md">
          <div className="overline mb-3">Sign in</div>
          <h1 className="font-display text-3xl text-[#F9F6F0] mb-10">Admin Dashboard</h1>

          <form onSubmit={submit} className="space-y-8" data-testid="admin-login-form">
            <div>
              <label className="overline">Email</label>
              <input
                type="email"
                required
                data-testid="admin-email-input"
                className="input-line mt-2"
                value={form.email}
                onChange={(e) => setForm({ ...form, email: e.target.value })}
              />
            </div>
            <div>
              <label className="overline">Password</label>
              <input
                type="password"
                required
                data-testid="admin-password-input"
                className="input-line mt-2"
                value={form.password}
                onChange={(e) => setForm({ ...form, password: e.target.value })}
              />
            </div>
            <button type="submit" disabled={loading} className="btn-solid w-full" data-testid="admin-submit-btn">
              {loading ? "Signing in…" : "Sign in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
